var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAchievement4A(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 205.2 205.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f5f7f8;}.cls-3{fill:#c5ced5;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4a") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "blank"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 205.2,
    height: 205.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 102.6,
    cy: 98.55,
    r: 53.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M102.6,47.81A50.74,50.74,0,1,1,51.86,98.55,50.8,50.8,0,0,1,102.6,47.81m0-6a56.74,56.74,0,1,0,56.74,56.74A56.74,56.74,0,0,0,102.6,41.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M119.63,123.69H87.88a3.06,3.06,0,0,1-3-3V83.06a3.06,3.06,0,0,1,3-3h4.81a.89.89,0,0,1,0,1.78H87.88a1.27,1.27,0,0,0-1.27,1.27v37.58a1.27,1.27,0,0,0,1.27,1.27h31.75a1.27,1.27,0,0,0,1.27-1.27V83.06a1.27,1.27,0,0,0-1.27-1.27h-5.35a.89.89,0,0,1,0-1.78h5.35a3.06,3.06,0,0,1,3.05,3v37.58A3.06,3.06,0,0,1,119.63,123.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M100.1,91.66v7.65H92.44V91.66h7.66m0-1.79H92.44a1.79,1.79,0,0,0-1.78,1.79v7.65a1.78,1.78,0,0,0,1.78,1.78h7.66a1.78,1.78,0,0,0,1.78-1.78V91.66a1.79,1.79,0,0,0-1.78-1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113.15,94.89h-8.21a.9.9,0,0,1,0-1.79h8.21a.9.9,0,0,1,0,1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M111,98.92h-6a.89.89,0,0,1,0-1.78h6a.89.89,0,1,1,0,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113.15,108.36h-8.21a.89.89,0,0,1,0-1.78h8.21a.89.89,0,0,1,0,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M111,112.4h-6a.89.89,0,0,1,0-1.78h6a.89.89,0,0,1,0,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M100.1,106.57v7.65H92.44v-7.65h7.66m0-1.78H92.44a1.78,1.78,0,0,0-1.78,1.78v7.65A1.79,1.79,0,0,0,92.44,116h7.66a1.79,1.79,0,0,0,1.78-1.79v-7.65a1.78,1.78,0,0,0-1.78-1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.48,70.1A5.53,5.53,0,0,1,109,75.61v2.7h5.29v6.07H92.69V78.31H98v-2.7a5.52,5.52,0,0,1,5.5-5.51m0-1.78a7.3,7.3,0,0,0-7.29,7.29v.92h-3.5a1.79,1.79,0,0,0-1.79,1.78v6.07a1.79,1.79,0,0,0,1.79,1.79h21.59a1.78,1.78,0,0,0,1.78-1.79V78.31a1.78,1.78,0,0,0-1.78-1.78h-3.51v-.92a7.3,7.3,0,0,0-7.29-7.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.54,74.64a1.62,1.62,0,1,1-1.62,1.62,1.62,1.62,0,0,1,1.62-1.62m0-1.78a3.4,3.4,0,1,0,3.4,3.4,3.4,3.4,0,0,0-3.4-3.4Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchievement4A);
export default __webpack_public_path__ + "static/media/achievement_4a.20dff94cddd6bcfddc5118ab204cf312.svg";
export { ForwardRef as ReactComponent };